module.exports = __webpack_public_path__ + "static/img/Inspection22.12a43b5a.jpg";